<div id="wheel-of-fortune" class="">
    <canvas class="w-100 ratio-1x1"></canvas>
    <audio id="snd-spin" src="/sounds/spin.mp3" type="audio/mpeg"></audio>
</div>